/*
//Personalizar header on scroll
window.addEventListener('scroll', function(){
  //document.querySelectorAll(".toggle_nav").forEach(e => e.classList.toggle("oculto"));
  if (window.scrollY >= 150) {
    document.querySelector(".site-header__wrapper__right .toggle_nav").classList.remove("oculto");
    document.querySelector(".site-header__wrapper__center.toggle_nav").classList.add("oculto");
    document.querySelector(".site-header__wrapper__left .toggle_nav").classList.remove("oculto");
    document.querySelector(".site-header__nav-standalone.toggle_nav").classList.add("oculto");
    document.querySelector(".site-header__wrapper__left").style.display = "contents";

    let target = document.getElementById('top_links_wrapper');
    document.querySelector(".site-header__wrapper__right .toggle_nav").appendChild(target);

  } else if (window.scrollY == 0) {
    document.querySelector(".site-header__wrapper__right .toggle_nav").classList.add("oculto");
    document.querySelector(".site-header__wrapper__center.toggle_nav").classList.remove("oculto");
    document.querySelector(".site-header__wrapper__left .toggle_nav").classList.add("oculto");
    document.querySelector(".site-header__nav-standalone.toggle_nav").classList.remove("oculto");
    document.querySelector(".site-header__wrapper__left").style.display = "flex";

    let target = document.getElementById('top_links_wrapper');
    document.querySelector(".site-header__nav-standalone.toggle_nav").appendChild(target);
  }
}, true)
//Personalizar header on scroll
*/

//elemento más alto
function eventHeight(div){
  if (window.innerWidth > 768){
    let maxHeight = -1;
    let allDivs = document.querySelectorAll(div);
    allDivs.forEach((element) => {
      maxHeight = maxHeight > element.offsetHeight ? maxHeight : element.offsetHeight;
    });
    document.querySelectorAll(div).forEach(element =>{
      element.style.height = maxHeight + 'px';
    })
  }
}
document.querySelectorAll(".product-grid--title").forEach(element =>{
  element.style.height = "auto";
})

window.addEventListener('load', function () {
  eventHeight(".collection-main-body-inner .product-grid--title");
  eventHeight(".product-page-related-products .product-grid--title");
  //eventHeight(".featured-product--grid-item .product-grid--title a");
})
setTimeout ( () => {
  eventHeight(".featured-product--grid-item .product-grid--title")
}, 1000);
//elemento más alto


//Personalizar alert privacidad checkout
$(document).ready(function() { $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', 
function() { if ($('#agree').is(':checked')) { $(this).submit(); } 
else { alert("Debes aceptar la política de privacidad para pasa a pago."); return false; } }); });
//Personalizar alert privacidad checkout


//GOLDEN CIRCLE
let goldenPasos = document.querySelectorAll(".paso");
let paso_actual = 0;

goldenPasos.forEach(element =>{
  element.addEventListener("mouseover", function(e){
    document.querySelectorAll(".paso").forEach(element =>{
      element.style.opacity = .4;
    })
    element.style.opacity = 1;
    document.querySelector("#" + element.id + "-texto").style.display = "block";
    document.querySelector(".paso-texto-ini").style.display = "none";
  });

  element.addEventListener("mouseout", function(e){
    element.style.opacity = .4;
    document.querySelectorAll(".paso").forEach(element =>{
      element.style.opacity = 1;
    })

    document.querySelectorAll(".paso-texto").forEach(element =>{
      element.style.display = "none";
    })
    document.querySelector(".paso-texto-ini").style.display = "block";
  });
});


if (document.getElementById("GOLDEN_CIRCLE_BOU") !== null) {
  document.getElementById("flecha_iz_desk").addEventListener("click", retrocederPaso);
  document.getElementById("flecha_dr_desk").addEventListener("click", avanzarPaso);
  document.getElementById("flecha_iz").addEventListener("click", retrocederPaso);
  document.getElementById("flecha_dr").addEventListener("click", avanzarPaso);
}

function avanzarPaso(){
  paso_actual += 1;
  if (paso_actual === 7) {
    paso_actual = 0;
  }
  mostrarPaso(paso_actual);
}
function retrocederPaso(){
  paso_actual -= 1;
  if (paso_actual === -1) {
    paso_actual = 6;
  }
  mostrarPaso(paso_actual);
}

function mostrarPaso(paso_actual){
  document.querySelectorAll(".paso").forEach(element =>{
    element.style.opacity = .4;
  })
  document.querySelectorAll(".paso-texto").forEach(element =>{
    element.style.display = "none";
  })
  if(paso_actual == 0){
    document.querySelector(".paso-texto-ini").style.display = "block";
  } else{
    document.querySelector("#paso-" + paso_actual).style.opacity = 1;
    document.querySelector("#paso-" + paso_actual + "-texto").style.display = "block";
    document.querySelector(".paso-texto-ini").style.display = "none";
  }

}

//GOLDEN CIRCLE


 $( ".pack-welcome-2-1 #SingleOptionSelector-0" ).change(function() {
      location.reload();
    });

    // Script Botons

    let product_types = $('#SingleOptionSelector-0 option');

    console.log(product_types);

    if ($('.option_GRANO').length){
      console.log('espero que no vagi lent');
    }

    if ($('#boton_grano').length){
      console.log('aaaabbbbbccccc');
    }

// let boton_grano = document.getElementById('boton_grano');

//   boton_grano.addEventListener("click", function() {
//   console.log("Hello!");
// });

// $(document).ready(function() {
//   console.log('pagina cargada');

//   let boton_grano = document.getElementById('boton_grano');

//   boton_grano.addEventListener("click", function() {
//   console.log("Hello!");
// });

//   $('#boton_grano').click(function(){console.log('hola');})
// })



//    $('#boton_grano').click(function(){console.log('hola');})

function resize_imatges() {
  if ($('.fila-seo-1').length){
    let bloques = $('.fila-seo-1 .container-texto-seo');
    // console.log(bloques.height());
    $('.fila-seo-1 .container-imagen-seo img').height(bloques.height());
  }

  if ($('.fila-seo-2').length){
    let bloques2 = $('.fila-seo-2 .container-texto-seo');
    // console.log(bloques2.height());
    $('.fila-seo-2 .container-imagen-seo img').height(bloques2.height());
  }

  if ($('.fila-seo-3').length){
    let bloques3 = $('.fila-seo-3 .container-texto-seo');
    // console.log(bloques3.height());
    $('.fila-seo-3 .container-imagen-seo img').height(bloques3.height());
  }

  if($('.comprar-cafe-de-especialidad-cafes-bou')){
    let tam_tit = $('#shopify-section-template--14821903499353__3e785bc1-8624-45c7-995c-03b0a9da3a4a .sitewide--title-wrapper').height();
    // console.log('Tamaño titulo -> ' + tam_tit)
    let tam_text = $('#shopify-section-template--14821903499353__3e785bc1-8624-45c7-995c-03b0a9da3a4a .featured-row__subtext').height();
    // console.log('Tamaño text -> ' + tam_text)

    let altura_final = tam_text + tam_tit + 60;

    $('#shopify-section-template--14821903499353__3e785bc1-8624-45c7-995c-03b0a9da3a4a img').height(altura_final);
  }
}

function resize_product() {
    
}

$(document).ready(function() {
  resize_imatges();

  $( window ).resize(function() {
    resize_imatges();
  })
})
